import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get("sidebarStatus"),
      withoutAnimation: false
    },
    listReq: {
      $size: 30,
      $page: 1
    },
    pageSizeArr: [10, 30, 100, 200, 500, 1000],
    ReChargeStatus: {
      1: "待审核",
      2: "拒绝",
      3: "审核通过",
      4: "已追分"
    },
    PayMethodType: {
      1: "支付宝个人账户",
      2: "支付宝个人吱口令",
      3: "支付宝个人二维码",
      4: "支付宝个人收款码",
      5: "支付宝个人转银行卡",
      6: "支付宝花呗",
      7: "支付宝信用卡",
      8: "微信个人收款码",
      9: "微信个人转银行卡",
      10: "微信信用卡",
      11: "银行卡支付",
      12: "USDT支付"
    },
    RecepiptMethodType: {
      1: "支付宝个人收款",
      2: "支付宝商家收款",
      3: "微信个人收款",
      4: "微信商家收款",
      5: "银行卡收款"
    },
    UserLevel: {
      0: "免费用户",
      1: "普通用户",
      2: "中级用户",
      3: "高级用户"
    },
    AgentLevel: {
      1: "1级",
      2: "2级",
      3: "3级"
    },
    RecepiptType: [{
        id: 1, //支付宝/微信/银联/花呗/信用卡
        name: "支付宝",
        children: [{
            id: 1,
            name: "个人支付宝",
            accountName: "支付宝账号"
          },
          {
            id: 2,
            name: "商户支付宝"
          }
        ]
      },
      {
        id: 2,
        name: "微信",
        children: [{
            id: 3,
            name: "个人微信",
            accountName: "微信账号"
          },
          {
            id: 4,
            name: "商户微信"
          }
        ]
      },
      {
        id: 3,
        name: "银行卡",
        children: [{
          id: 5,
          name: "个人银行卡"
        }]
      },
      {
        id: 4,
        name: "USDT",
        children: [
          {
            id: 6,
            name: "USDT"
          },
        ]
      }
    ],
    accountType: {
      1: '支付宝账号',
      2: '微信账号',
      3: '银行卡账号',
      4: '钱包地址'
    },
    nameEnumeration: {
      1: '支付宝姓名',
      2: '微信昵称',
      3: '银行卡姓名',
      4: '账号名称'
    },
    payType: {
      1: "支付宝",
      2: "微信",
      3: "花呗",
      4: "信用卡",
      5: "银行卡",
      6: 'USDT',
    },
    qiniuUrl: "http://image.syyyd.net/",
    BankCode: {
      ICBC: '工商银行',
      CCB: '建设银行',
      BOC: '中国银行',
      ABC: '农业银行',
      BCM: '交通银行',
      CMB: '招商银行',
      PSBC: '邮政银行',
      CNCB: '中信银行',
      CEB: '光大银行',
      HXB: '华夏银行',
      SPDB: '浦发银行',
      CIB: '兴业银行',
      CMBC: '民生银行',
      PAB: '平安银行',
      CGB: '广发银行',
      HRBB: '哈尔滨银行',
      CZB: '浙商银行',
      QDCCB: '青岛银行',
      CSCB: '长沙银行',
      NJCB: '南京银行',
      RCB: '农村商业银行',
      OTHERS: '其它银行'
    },
    orderStatus: {
      1: "未充值",
      2: "提交第三方",
      3: "充值成功",
      4: "充值失败",
      5: "已取消（手动取消）",
      6: "超时过期",
      7: "追分成功",
      8: "待审核",
      9: "审核失败",
      10: "充值成功",
      11: "追分中"
    },
    userType: {
      new_user: '新用户',
      next_day: '次日用户',
      week_user: '周用户',
      veteran_user: '老用户'
    },
    orderType: {
      1: "手动充值",
      2: "自动充值",
      3: "自动充值"
    },

    sensitiveType: {
      0: '图片监控',
      1: '敏感性词监控',
    },
    wordsTatus: {
      0: '待处理',
      1: '已通过',
      2: '已处罚',
    },
    agencyOperatorRole: {
      1: '代理运营',
      2: '用户运营',
      3: '财务运营',
      4: '监控运营'
    },
    // 变动类型
    agencyTransactionType: {
      '1': '总代充值',
      '2': '子代充值', // 代理充值，总代扣除相应的钱
      '3': '子代充值',
      '4': '用户充值',
      '5': '用户充值追分',
      '6': '用户充值失败返款',
      '7': '总代充值追分',
      '8': '子代充值追分', // 子代被总代追分
      '9': '子代充值追分', // 总代追子代分，自己加钱
      '10': '系统调整', //通知商户上分，商户成功，却返回失败，手动追代理分
    },
    transactionType_agency: {
      '1': '总代充值',
      '7': '总代充值追分',
      '2': '子代充值',
      '9': '子代充值追分',
      '10': '系统调整',
    },
    transactionType_childAgency: {
      '3': '子代充值',
      '8': '子代充值追分',
      '4': '用户充值',
      '5': '用户充值追分',
      '10': '系统调整',
    },
    evaluationType: {
      1: '不满意',
      5: '满意'
    },
    reportStatus: {
      'new': '新建',
      'doing': '报表导出中',
      'done': '完成'
    },
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set("sidebarStatus", 1);
      } else {
        Cookies.set("sidebarStatus", 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    }
  },
  actions: {
    ToggleSideBar: ({
      commit
    }) => {
      commit("TOGGLE_SIDEBAR");
    }
  }
};

export default app
